// removed by extract-text-webpack-plugin
module.exports = {"RealizedPortfolio":"RealizedPortfolio","TabTable":"TabTable","TabContent":"TabContent","tab-pane":"tab-pane","TabBoard":"TabBoard","TabAccount":"TabAccount","Default":"Default","PortfolioData":"PortfolioData","ag-root":"ag-root","ag-row":"ag-row","Cell":"Cell"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/RealizedPortfolio/styles.scss
// module id = 2012
// module chunks = 10